<template>
  <div class="container-simple-table">
    <div class="header-table">
      <div class="search-container">
        <feather v-if="loadingtable"
                 class="refreshtable"
                 :class="(loadingtable === true) ? 'animation-refresh' : 'stop'"
                 type="refresh-cw" size="18px"
                 @click="(!loadingtable) ? $emit('update-table') : null"
        />
        <search width="70%" height="35px" @searchtext="searchData($event)" />
      </div>
      <div class="left-side-container">
        <div class="select-rows-qt">
          <select id="" v-model="rowsperpagechange" class="select-container"
                  title="Selecionar quantidade de linhas"
                  @change="rowsperpage = rowsperpagechange"
          >
            <option :value="10">
              10 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
            <option :value="30">
              30 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
            <option :value="50" selected>
              50 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
            <option :value="100">
              100 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom}` }}
            </option>
          </select>
        </div>
        <kfilter :filter-visibility="filterVisibility" @apply="modalSendData()"
                 @open-filter="filterVisibility = true"
                 @clear="clearFilter()"
        >
          <template v-slot:container>
            <div class="dateselect-container">
              <b-checkbox v-model="initDate" size="is-small" class="checkbox-date">
                Data Início
              </b-checkbox>
            </div>
            <div v-if="initDate" class="date-box animate__animated animate__fadeInRight">
              <b-input v-model="initDateInput[0]" type="date" size="is-small"
                       class="input-date-picker"
              />
              <b-input
                v-model="initDateInput[1]"
                type="date"
                size="is-small"
                class="input-date-picker"
              />
            </div>
          </template>
        </kfilter>
      </div>
    </div>

    <b-table
      :data="isEmpty ? [] : data"
      :selected.sync="selected"
      :total-pages="mytotalPages"
      :current-page="(currentpage !== 0 && currentpage !== undefined) ? currentpage : 1"
      :total="totalPages"
      :paginated="(isEmpty === false ) ? true : false"
      :per-page="rowsperpage"
      pagination-size="is-small"
      :loading="loadingtable"
      focusable
      backend-pagination
      @page-change="pagechange($event)"
    >
      <b-table-column
        v-slot="props"
        field="acoes"
        label="Ações"
        width="40"
        centered
        header-class="custom-header"
      >
        <b-dropdown aria-role="list">
          <h1 slot="trigger" class="row-actions-circles">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
          </h1>
          <b-dropdown-item
            aria-role="listitem"
            disabled
            @click="$router.push(`edit/${props.row.comp_produtoparam_id}`)"
          >
            <div class="menu-row-option">
              <feather class="menu-row-icon check" type="edit" size="16" />
              <h1>Editar</h1>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="id"
        label="Componente ID"
        width="150"
        header-class="custom-header"
        numeric
      >
        <h1 :ref="'a'+props.row.comp_produtoparam_id" class="table-title-cad id">
          {{ props.row.comp_produtoparam_id }}
        </h1>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="sincronizacaoid"
        label="Componente"
        header-class="custom-header"
        centered
      >
        <span class="table-title-cad sincronizacaoid">
          {{ props.row.titulo }}
        </span>
      </b-table-column>
    </b-table>
    <Empty
      v-if="data.length <= 0 && loadingtable === false"
      message="Nenhum item encontrado"
      subtitle="Tente alterar os filtros"
    />
  </div>
</template>

<script>
import kfilter from '../filter/custom';
import search from '../search/index';
import Empty from '../empty/index';
import 'vue-context/src/sass/vue-context.scss';

export default {
	components: {
		search,
		kfilter,
		Empty,
	},

	props: {
		data: {
			type: Array,
			default: () => [],
		},
		loadingtable: {
			type: Boolean,
			default: true,
		},
		labels: {
			type: Array,
			default: () => [],
		},
		totalPages: {
			type: Number,
			default: 0,
		},
		currentpage: {
			type: Number,
			default: 1,
		},
	},

	data() {
		return {
			initDateInput: [],
			value: '',
			filterVisibility: false,
			initDate: false,
			rowsperpage: 50,
			rowsperpagechange: 50,
			rowsperpageCustom: '',
			userPageStatus: 0,
			lastpage: null,
			pageRows: 0,
			selected: {},
			mytotalPages: 0,
			searchTerm: '',
		};
	},
	computed: {
		isEmpty() {
			if (this.data.length <= 0) {
				return true;
			}
			return false;
		},
	},
	watch: {
		rowsperpagechange() {
			this.pagechange(this.lastpage);
		},
		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
	},
	created() {
		this.pagechange(1);
	},
	methods: {
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		searchData(searchTerm) {
			if (this.initDateInput[0] && this.initDateInput[1]) {
				this.$emit('search-text', {
					offset: 0,
					limit: this.rowsperpagechange,
					orderby: 'dt_inicio',
					dt_inicio: this.initDateInput[0],
					dt_fim: this.initDateInput[1],
					searchTerm,
					direction: 'asc',
				});
			} else {
				this.$emit('search-text', {
					offset: 0,
					limit: this.rowsperpagechange,
					orderby: 'dt_inicio',
					dt_inicio: '',
					dt_fim: '',
					searchTerm,
					direction: 'asc',
				});
			}
		},
		clearFilter() {
			this.initDateInput = ['', ''];
			this.initDate = false;
		},
		modalSendData() {
			if (this.initDateInput[0] && this.initDateInput[1]) {
				this.$emit('apply-modal', {
					offset: 0,
					limit: this.rowsperpagechange,
					orderby: 'dt_inicio',
					dt_inicio: this.initDateInput[0],
					dt_fim: this.initDateInput[1],
					searchTerm: '',
					direction: 'asc',
				});
				this.filterVisibility = false;
			}
		},

		pagechange(pagenumber) {
			this.$emit('pagechange', {
				searchTerm: this.searchTerm,
				dt_inicio: this.initDateInput[0],
				dt_fim: this.initDateInput[1],
				direction: 'asc',
				orderby: 'dt_inicio',
				offset: (pagenumber * this.rowsperpagechange) - this.rowsperpagechange,
				limit: this.rowsperpagechange,
			}, pagenumber);
			this.lastpage = pagenumber;
			this.rowsperpageCustom = (pagenumber * this.rowsperpagechange) + 1;
			this.userPageStatus = (this.rowsperpageCustom - this.rowsperpagechange);
		},
		changeOption(e) {
			this.$emit('changeOption', e);
		},

		showContext(row, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context, row);
		},
	},
};
</script>

<style lang="scss" scoped>

.circle {
  width: 5px;
  height: 5px;
  margin: 1px;
  border-radius: 50%;
  background-color: rgb(212, 212, 212);
    transition: ease-in-out 0.5s;
}
.row-actions-circles {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.row-actions-circles:hover  {
    cursor: pointer;
}
.row-actions-circles:hover .circle {
   background-color: rgb(139, 139, 139);
}

.checkbox-date {
  width: 100%;
  padding: 10px 10px 10px 0px;
  border-bottom: 1px solid rgba(204, 204, 204, 0.411);
}
.date-box {
  display: flex;
}
.input-date-picker {
  width: 45%;
  font-size: 5px;
}
.input-date-picker:first-child {
  margin-right: 8px;
}
.dateselect-container {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  animation: all 1s ease-in;
}
.dateselectinput:first-child{
  margin-right: 10px;
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  transition: 0.5s ease-in-out;
}

.empty p {
  color: #25213b;
  font-weight: bold;
}
.img-empty {
  width: 35%;
}

.search-container {
  width: 60%;
  display: flex;
  align-items: center;
}

.refreshtable {
  margin-right: 20px;
  color: #00C9A7;
  cursor: pointer;
}

.animation-refresh {
    -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.container-simple-table {
  margin-bottom: 30px;
  padding-bottom: 20px;
  background-color: #FFF;
}

.left-side-container {
  display: flex;
  height: 35px;
}
.select-container {
  all: unset;
  width: 150px;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 20px;
  border:1px solid #e2e2e2;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 15px;
  font-size: 12px;
  color: rgb(98, 98, 98);
}

.span-rounded {
  width: 50px;
  height: 50px;
  background-color: #25213b;
}
.header-table {
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  padding: 20px;
}

  .about-more {
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  color: #6e6893;
  font-weight: normal;
}

.int-id,
.email,
.user,
.id {
  font-size: 12px;
   font-weight: 400;
   color: #626262;
}
.table-title-cad {
  color: $row-color;
  font-weight: $row-weight;
  margin-top: 5px;
  margin-bottom: 2px;
  font-size: $row-size;
}

.custom-header {
  font-size: $header-size;
  font-weight: $header-weight;
  color: $header-color;
}

/* .tag-status {

    color: #FFF;

} */

.is-success {
  display: flex;

  align-items: center;
}

.menu-row-icon {
  color: #8b83ba;

  padding-left: 10px;

  padding-right: 10px;

  font-weight: 500;
}

.menu-row-box-bottom {
  padding-top: 10px;
}

.menu-row-box {
  padding-bottom: 10px;

  border-bottom: 1px solid #f2f0f9;
}

.menu-row-option:first-child {
  margin-top: 5px;
}

.menu-row-option:hover {
  background-color: #f2f0f9 !important;

  color: #25213b !important;

  border-radius: 5px;
}

.menu-row-option:hover .danger {
  color: #dc3545 !important;
}

.menu-row-option:hover .check {
  color: #007f00;
}

.menu-row-option:hover .archive {
  color: #f77f00;
}

.menu-row-option {
  display: flex;

  align-items: center;

  margin-left: 5px;

  margin-right: 5px;

  padding: 10px;

  cursor: pointer;
}
</style>
>
